var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.618,
    height: 27.802,
    viewBox: "0 0 28.618 27.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home_1_",
    "data-name": "home (1)",
    transform: "translate(-3.28 -50.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1652",
    "data-name": "Group 1652",
    transform: "translate(4.48 52.037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6078",
    "data-name": "Path 6078",
    d: "M78.807,120.939,65.721,132.512a.355.355,0,0,1-.011.073.356.356,0,0,0-.011.073v11.719a1.556,1.556,0,0,0,.433,1.1,1.356,1.356,0,0,0,1.024.464h8.739v-9.375H81.72v9.375h8.739a1.354,1.354,0,0,0,1.024-.465,1.556,1.556,0,0,0,.433-1.1V132.658a.366.366,0,0,0-.023-.146Z",
    transform: "translate(-65.698 -120.939)",
    fill: "none",
    stroke: "#353665f7",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.09adeccd9286fae3ba74fc3a387eea4a.svg";
export { ForwardRef as ReactComponent };